export default __webpack_public_path__ + "static/media/woodcut-skeleton.9318abd0.png";